import gql from 'graphql-tag'

export const FETCH_TAGS_NEWS = gql`
    query fetchTagsNews {
        tagsNews {
            name
            id
        }
    }
`